// extracted by mini-css-extract-plugin
module.exports = {"primaryItem":"_497d7fcb","primaryLink":"_b26d545e","primaryImage":"_a9fe499","productItems":"_e6f03a9f","shimmerLoadingBackground":"_a457867f"};